import React, { useMemo } from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const ManageMember = ({ member, match, user }) => {
  const { operator: { id } } = React.useContext(AppContext)
  const token = useMemo(() => window.localStorage.getItem('auth-token'), [])

  if (!id) {
    return (
      <div className='index memberships' />
    )
  }

  return (
    <div className='membership manage'>
      <cl-membership-management
        apiHost={`https://memberships.${env()}.credlock.net`}
        mountPath={`/operators/${id}/members`}
        operatorid={id}
        token={token}
        id={member.id}
      />
    </div>
  )
}

export default ManageMember
